import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';
import BaseInput from '../helpers/Input';
import ErrorDisplay from '../decorators/DisplayError';
import PrettyError from '../decorators/PrettyError';
import { EmailFinderField } from './EmailFinderField';

const Input = PrettyError(ErrorDisplay(BaseInput));

const EditEmailContactChannel = props => {
  const { isNew, onChange, channel, isValid, onSave, onFindEmail } = props;

  const prefix = isNew ? 'Create' : 'Change';
  const header = `${prefix} contact\'s email`;
  const footer = (
    <Button className="btn-primary" disabled={!isValid} onClick={onSave}>
      {isNew ? 'Create' : 'Save'}
    </Button>
  );

  return (
    <Popup footer={footer} header={header} id="newExecProf">
      <div className="row">
        <FormGroup className="col-lg-7 col-sm-7">
          <EmailFinderField onFindEmail={onFindEmail}>
            <Input
              className="input-md"
              label="E-mail"
              name="email"
              onChange={onChange}
              placeholder="E-mail"
              root={channel}
              type="emailVerify"
              autoFocus
              deep
              showLabel
            />
          </EmailFinderField>
        </FormGroup>
        <FormGroup className="col-lg-5 col-sm-5">
          <Input
            className="input-md"
            label="Type"
            name="type"
            onChange={onChange}
            placeholder="Type"
            root={channel}
            deep
            showLabel
          />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(EditEmailContactChannel);
